import CommonLayout from '../common-layout';
import { useContext, useState, useEffect } from 'react';
import { ReactComponent as DownIcon } from 'assets/icon/chevron-down.svg';
import { setSideModal } from 'store/features/modelSlice';
import { emailRegEx, initSideModal, usersRoles } from 'helpers/utils';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import VehicleDetails from './vehicle-details';
import UsersDetails from './users-details';
import { IAddress } from 'interfaces/common-interfaces';
import { IDefaultOption } from 'components/common/select';
import { addDMSVehicle, getDMSData, getDMSProviders, setDMSDeatils } from 'store/features/dmsSlice';
import { AppContext } from 'context/app-context';
import toast from 'react-hot-toast';
import { getOrganizationListWithAssociateParking } from 'store/features/administratorRoleSlice';
import {
  getDeviceProvidersList,
  getEngineList,
  getTireSizeList,
} from 'store/features/vehicleConfigSlice';
import { getCompanyList } from 'store/features/companySlice';
import { IDevice } from 'interfaces/vehicle-config-interfaces';
import { IAddEditVehicleRequestBody, IVehiclesFilters } from 'interfaces/vehicle-interface';
import { IAddClientUserRequest } from '../add-user';
import moment from 'moment';
import { getVehiclesList } from 'store/features/vehicleSlice';
import { useTranslation } from 'react-i18next';

type ITabType = 'VEHICLE_DETAILS' | 'USER_DETAILS';

export interface IDMSVehicleDetails {
  registration_date: string;
  purchase_date?: string;
  brand: { id: string; name: string } | null;
  // model: { id: string; name: string } | null;
  model: string;
  assigned_user?: string;
  vin: string;
  km: number;
  engine: { id: string; name: string } | null;
  is_used: boolean;
  fuel_type?: IDefaultOption | null;
  organization: IDefaultOption | null;
  selectedParkingAddress: IAddress | null;
  associtedCompany?: IDefaultOption | null;
  device?: string;
  provider?: IDefaultOption | null;
  category?: IDefaultOption | null;
  front_tire_size?: IDefaultOption | null;
  rear_tire_size?: IDefaultOption | null;
  type?: IDefaultOption | null;
  plate: string;
  tutaion?: string;
  frame?: string;
  transmission: IDefaultOption | null;
  environmental_label: IDefaultOption | null;
  doors?: string;
  places?: string;
  status: IDefaultOption | null;
  version?: string;
}

export interface IDMSUserDetails {
  name: string;
  surname: string;
  email: string;
  country_code: string;
  mobile_no: string;
  date_of_birth?: string;
  dni_exp_date?: string;
  dni_no?: string;
  license_exp_date?: string;
  license_no: string;
  policy_exp_date?: string;
  policy_no?: string;
  address?: IAddress | null;
  billing_address?: IAddress | null;
}
export interface IDMSData {
  vehicle_details: IDMSVehicleDetails;
  user_details: IDMSUserDetails;
}

const tabs = [
  { name: 'Vehicle details', value: 'VEHICLE_DETAILS' },
  { name: 'User details', value: 'USER_DETAILS' },
];
const initVehicleData: IDMSVehicleDetails = {
  registration_date: '',
  brand: null,
  engine: null,
  environmental_label: { id: 'NONE', name: 'NONE', value: 'NONE' },
  km: 0,
  model: '',
  organization: null,
  plate: '',
  selectedParkingAddress: null,
  transmission: null,
  vin: '',
  status: { id: 'ACTIVE', name: 'Active', value: 'Active' },
  front_tire_size: null,
  rear_tire_size: null,
  is_used: false,
};
export interface IDMSVehicleDetailsError {
  organization?: string;
  front_tire_size?: string;
  rear_tire_size?: string;
  engine?: string;
  plate?: string;
  trasmission?: string;
  env_label?: string;
  status?: string;
  device_provider?: string;
  device?: string;
}
export interface IDMSUserDetailsError {
  name?: string;
  surname?: string;
  email?: string;
  mobile_number?: string;
  license_no?: string;
}
interface IDMSErrors {
  vehicleError: IDMSVehicleDetailsError;
  userError: IDMSUserDetails;
}
const initUserData: IDMSUserDetails = {
  country_code: '',
  email: '',
  license_no: '',
  mobile_no: '',
  name: '',
  surname: '',
};

const DMSIntegration = () => {
  const { setLoader } = useContext(AppContext);

  const dispatch = useAppDispatch();

  const { selectedOrganization } = useAppSelector(state => state.auth);
  const { dmsData } = useAppSelector(state => state.DMS);
  const { engines, tireSizes, deviceProviders } = useAppSelector(state => state.vehicleConfig);
  const { companies } = useAppSelector(state => state.company);

  const [selectedTab, setSelectedTab] = useState<ITabType>('VEHICLE_DETAILS');
  const [DMSData, setDMSData] = useState<IDMSData>({
    vehicle_details: initVehicleData,
    user_details: initUserData,
  });
  const [vinNumber, setVinNumber] = useState<string>('');
  const [selectedDevice, setSelectedDevice] = useState<IDevice | null>(null);
  const [tireSizeOption, setTireSizeOption] = useState<IDefaultOption[]>([]);
  const [engineOption, setEngineOption] = useState<IDefaultOption[]>([]);
  const [companyOption, setCompanyOption] = useState<IDefaultOption[]>([]);
  const [deviceProviderOption, setDeviceProviderOption] = useState<IDefaultOption[]>([]);
  const [error, setError] = useState<IDMSErrors>();

  const isSuperAdmin = selectedOrganization?.role_name === usersRoles.SUPER_ADMIN;
  const isDealerAdmin = selectedOrganization?.role_name === usersRoles.DEALER_ADMIN;
  const isFleetManager = selectedOrganization?.role_name === usersRoles.FLEET_MANAGE;

  const { t } = useTranslation();
  const handleSearch = async () => {
    try {
      if (!vinNumber.trim()) {
        toast.error(t('dms_Integartion.errorVINumberToastMessage'));
        return;
      }
      setLoader(true);
      await dispatch(
        getDMSData({ vin: vinNumber!, request: { dms_provider_id: '65e815d8c03483a4050a20b0' } }),
      ).catch(err => {
        setLoader(false);
      });
      setLoader(false);
    } catch (err) {
      toast.error(t('dms_Integartion.errorFetchingDMS'));
      setLoader(false);
    }
  };
  const getOrganizationListAndParking = async () => {
    try {
      let params = isDealerAdmin ? { organization_id: selectedOrganization?.organization_id } : {};
      if (isDealerAdmin || isSuperAdmin) {
        await dispatch(
          getOrganizationListWithAssociateParking({
            params,
          }),
        ).catch(() => {
          setLoader(false);
        });
      }
      return Promise.resolve(true);
    } catch (error) {
      setLoader(false);
      return Promise.reject(false);
    }
  };
  const getAllOptions = async () => {
    try {
      setLoader(true);
      const promises = [
        getOrganizationListAndParking(),
        dispatch(getTireSizeList({})),
        dispatch(getEngineList({})),
        dispatch(getCompanyList({ params: {}, url: '' })),
        dispatch(getDeviceProvidersList({})),
        dispatch(getDMSProviders()),
      ];
      const res = await Promise.all(promises).catch(err => {
        setLoader(false);
        return Promise.reject(err);
      });
      setLoader(false);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  useEffect(() => {
    getAllOptions();
  }, []);
  useEffect(() => {
    try {
      if (dmsData) {
        const updatedDMSDATA: IDMSData = {
          user_details: {
            ...DMSData?.user_details,
            name: dmsData?.userDetail?.name || '',
            surname: dmsData?.userDetail?.surname || '',
            email: dmsData?.userDetail?.email || '',
            date_of_birth: dmsData?.userDetail?.birth_date || '',
            address: {
              address1: dmsData?.userDetail?.address?.address1 || '',
              address2: dmsData?.userDetail?.address?.address2 || '',
              city: DMSData?.user_details?.address?.city || '',
              country: DMSData?.user_details?.address?.country || '',
              state: DMSData?.user_details?.address?.state || '',
              zipcode: dmsData?.userDetail?.address?.zipcode || '',
            },
          },
          vehicle_details: {
            ...DMSData?.vehicle_details,
            brand: dmsData?.vehicleDetail?.brandDetail,
            doors: dmsData?.vehicleDetail?.doors,
            engine: dmsData?.vehicleDetail?.engineDetail,
            is_used: dmsData?.vehicleDetail?.is_used,
            km: dmsData?.vehicleDetail?.km,
            model: dmsData?.vehicleDetail?.modelDetail,
            places: dmsData?.vehicleDetail?.places,
            purchase_date: dmsData?.vehicleDetail?.purchase_date,
            registration_date: dmsData?.vehicleDetail?.registration_date,
            assigned_user:
              dmsData?.userDetail?.name || dmsData?.userDetail?.surname
                ? `${dmsData?.userDetail?.name} ${dmsData?.userDetail?.surname}`
                : '',
            vin: vinNumber || '',
            // version: dmsData?.vehicleDetail?.version || '',
          },
        };
        setDMSData(updatedDMSDATA);
      }
    } catch (error) {}
  }, [dmsData]);
  useEffect(() => {
    const updatedOptions: IDefaultOption[] = [...tireSizes].map(data => ({
      id: data?._id || '',
      name: data?.name,
    }));
    setTireSizeOption(updatedOptions);
  }, [tireSizes]);
  useEffect(() => {
    const updatedOptions: IDefaultOption[] = [...engines].map(data => ({
      id: data?._id || '',
      name: data?.name,
    }));
    setEngineOption(updatedOptions);
  }, [engines]);
  useEffect(() => {
    const updatedOptions: IDefaultOption[] = [...companies].map(data => ({
      id: data?._id || '',
      name: data?.name,
    }));
    setCompanyOption(updatedOptions);
  }, [companies]);
  useEffect(() => {
    const updatedOptions: IDefaultOption[] = [...deviceProviders].map(data => ({
      id: data?._id || '',
      name: data?.name,
    }));
    setDeviceProviderOption(updatedOptions);
  }, [deviceProviders]);
  const getContent = (tab: ITabType) => {
    switch (tab) {
      case 'VEHICLE_DETAILS':
        return (
          <VehicleDetails
            vehicle={DMSData?.vehicle_details}
            setVehicle={data => setDMSData({ ...DMSData, vehicle_details: data })}
            vinNumber={vinNumber}
            setVinNumber={vin => setVinNumber(vin)}
            handleSearch={handleSearch}
            tireSizeOption={tireSizeOption}
            engineOption={engineOption}
            companyOption={companyOption}
            deviceProviderOption={deviceProviderOption}
            selectedDevice={selectedDevice || null}
            setSelectedDevice={setSelectedDevice}
            vehicleError={error?.vehicleError || null}
          />
        );
      case 'USER_DETAILS':
        return (
          <UsersDetails
            user={DMSData?.user_details}
            setUser={data => setDMSData({ ...DMSData, user_details: data })}
            userError={error?.userError || null}
          />
        );
    }
  };
  const fetchVehicles = async () => {
    let params: Partial<IVehiclesFilters> = {};
    if (isSuperAdmin && isFleetManager) {
      params = {
        ...params,
        organization_id: [
          ...(params?.organization_id ?? []),
          ...(selectedOrganization?.organization_id ? [selectedOrganization.organization_id] : []),
        ],
      };
    }
    if (isFleetManager) {
      params = {
        ...params,
        company_id: [
          ...(params?.company_id ?? []),
          ...(selectedOrganization?.associated_company_id
            ? [selectedOrganization?.associated_company_id]
            : []),
        ],
      };
    }
    await dispatch(getVehiclesList({ request: params }))
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
  };
  const handleSubmit = async () => {
    try {
      setLoader(true);
      let request: {
        vehicleDetail: IAddEditVehicleRequestBody;
        userDetail: IAddClientUserRequest;
      } = {
        userDetail: {
          name: DMSData?.user_details?.name,
          surname: DMSData?.user_details?.surname,
          email: DMSData?.user_details?.email,
          country_code: DMSData?.user_details?.country_code,
          mobile_no: DMSData?.user_details?.mobile_no,
          birth_date: DMSData?.user_details?.date_of_birth
            ? moment(DMSData?.user_details?.date_of_birth).format('DD/MM/YYYY')
            : '',
          address:
            !DMSData?.user_details?.address ||
            Object.values(DMSData?.user_details?.address).filter(field => String(field)?.trim())
              .length === 0
              ? null
              : DMSData?.user_details?.address,
          dni_no: DMSData?.user_details?.dni_no || '',
          dni_exp_date: DMSData?.user_details?.dni_exp_date
            ? moment(DMSData?.user_details?.dni_exp_date).format('DD/MM/YYYY')
            : '',
          license_no: DMSData?.user_details?.license_no,
          license_exp_date: DMSData?.user_details?.license_exp_date
            ? moment(DMSData?.user_details?.license_exp_date).format('DD/MM/YYYY')
            : '',
          billing_address:
            !DMSData?.user_details?.billing_address ||
            Object.values(DMSData?.user_details?.billing_address).filter(
              field => String(field)?.trim(),
            ).length === 0
              ? null
              : DMSData?.user_details?.billing_address,
          policy_no: DMSData?.user_details?.policy_no || '',
          policy_exp_date: DMSData?.user_details?.policy_exp_date
            ? moment(DMSData?.user_details?.policy_exp_date).format('DD/MM/YYYY')
            : '',
          type_of_purchase_ids: [],
          vehicle_ids: [],
          role_details: [
            {
              role: usersRoles?.CLIENT,
              organization_id: isSuperAdmin
                ? DMSData?.vehicle_details?.organization?.id || ''
                : selectedOrganization?.organization_id || '',
            },
          ],
        },
        vehicleDetail: {
          organization_id: DMSData?.vehicle_details?.organization?.id || '',
          brand_id: DMSData?.vehicle_details?.brand?.id || '',
          model: DMSData?.vehicle_details?.model || '',
          registration_date: moment(DMSData?.vehicle_details?.registration_date).format(
            'DD/MM/YYYY',
          ),
          status: DMSData?.vehicle_details?.status?.name || '',
          plate: DMSData?.vehicle_details?.plate,
          chasis: DMSData?.vehicle_details?.vin,
          km: DMSData?.vehicle_details?.km,
          engine_id: DMSData?.vehicle_details?.engine?.id || '',
          parking_id: DMSData?.vehicle_details?.selectedParkingAddress?._id || '',
          environmental_label: DMSData?.vehicle_details?.environmental_label?.value || '',
          transmission: DMSData?.vehicle_details?.transmission?.value || '',
          is_used: DMSData?.vehicle_details?.is_used,
          front_tire_size_id: DMSData?.vehicle_details?.front_tire_size?.id || '',
          rear_tire_size_id: DMSData?.vehicle_details?.rear_tire_size?.id || '',
        },
      };
      if (DMSData?.vehicle_details?.device && DMSData?.vehicle_details?.provider?.id) {
        request = {
          ...request,
          vehicleDetail: {
            ...request?.vehicleDetail,
            device_detail: {
              imeie: DMSData?.vehicle_details?.device || '',
              provider_id: DMSData?.vehicle_details?.provider?.id,
            },
          },
        };
      }
      if (DMSData?.vehicle_details?.type?.id) {
        request = {
          ...request,
          vehicleDetail: {
            ...request?.vehicleDetail,
            vehicle_type: DMSData?.vehicle_details?.type?.id,
          },
        };
      }
      if (DMSData?.vehicle_details?.purchase_date) {
        request.vehicleDetail.purchase_date = moment(
          DMSData?.vehicle_details?.purchase_date,
        ).format('DD/MM/YYYY');
      }
      if (DMSData?.vehicle_details?.assigned_user) {
        request.vehicleDetail.user_id = DMSData?.vehicle_details?.assigned_user;
      }
      if (DMSData?.vehicle_details?.associtedCompany?.id) {
        request.vehicleDetail.associated_company = DMSData?.vehicle_details?.associtedCompany?.id;
      }
      if (DMSData?.vehicle_details?.category?.value) {
        request.vehicleDetail.category = DMSData?.vehicle_details?.category?.value;
      }
      if (DMSData?.vehicle_details?.type?.value) {
        request.vehicleDetail.vehicle_type = DMSData?.vehicle_details?.type?.value;
      }
      if (DMSData?.vehicle_details?.tutaion) {
        request.vehicleDetail.tuition = DMSData?.vehicle_details?.tutaion;
      }
      if (DMSData?.vehicle_details?.frame) {
        request.vehicleDetail.frame = DMSData?.vehicle_details?.frame;
      }
      if (DMSData?.vehicle_details?.fuel_type?.value) {
        request.vehicleDetail.fuel_type = DMSData?.vehicle_details?.fuel_type?.name;
      }
      // if (DMSData?.vehicle_details?.version) {
      //   request.vehicleDetail.version = DMSData?.vehicle_details?.version;
      // }
      if (DMSData?.vehicle_details?.doors) {
        request.vehicleDetail.doors = DMSData?.vehicle_details?.doors;
      }
      if (DMSData?.vehicle_details?.places) {
        request.vehicleDetail.places = DMSData?.vehicle_details?.places;
      }
      await dispatch(addDMSVehicle({ request })).catch(() => setLoader(false));
      setLoader(false);
      fetchVehicles();
      dispatch(setDMSDeatils(null));
      dispatch(setSideModal(initSideModal));
    } catch (error) {
      setLoader(false);
    }
  };
  const getErrorData = (errorFor: 'VEHICLE' | 'USER') => {
    let updatedError: IDMSErrors = error!;
    switch (errorFor) {
      case 'USER': {
        updatedError = {
          ...updatedError,
          userError: {
            ...updatedError?.userError,
            name: !DMSData?.user_details?.name.trim() ? t('errorName') : '',
            surname: !DMSData?.user_details?.surname.trim() ? t('errorSurname') : '',
            email: !DMSData?.user_details?.email.trim()
              ? t('administrator_roles.addEdit.errorEmail')
              : !emailRegEx.test(DMSData?.user_details?.email.trim())
              ? t('PLEASE_ENTER_VALID_EMAIL')
              : '',
            mobile_no:
              !DMSData?.user_details?.mobile_no.trim() ||
              !DMSData?.user_details?.country_code.trim()
                ? t('dms_Integartion.telephoneNo')
                : '',
            license_no: !DMSData?.user_details?.license_no.trim()
              ? t('dms_Integartion.licenseNo')
              : '',
          },
        };
        break;
      }
      case 'VEHICLE': {
        updatedError = {
          ...updatedError,
          vehicleError: {
            ...updatedError?.vehicleError,
            engine: !DMSData?.vehicle_details?.engine?.id ? t('PLEASE_ENTER_ENGINE') : '',
            env_label: !DMSData?.vehicle_details?.environmental_label?.id
              ? t('dms_Integartion.environmentalLabel')
              : '',
            organization: !DMSData?.vehicle_details?.organization?.id ? t('SELE_ORG') : '',
            plate: !DMSData?.vehicle_details?.plate.trim() ? t('PLEASE_SELECT_PLATE') : '',
            status: !DMSData?.vehicle_details?.status?.id ? t('PLEASE_SELECT_STATUS') : '',
            front_tire_size: !DMSData?.vehicle_details?.front_tire_size?.id
              ? t('PLEASE_SELECT_FRONT_TIRE_SIZE')
              : '',
            rear_tire_size: !DMSData?.vehicle_details?.rear_tire_size?.id
              ? t('PLEASE_SELECT_REAR_TIRE_SIZE')
              : '',
            trasmission: !DMSData?.vehicle_details?.transmission?.id
              ? t('PLEASE_SELECT_TRANSMISSION')
              : '',
            device_provider:
              !DMSData?.vehicle_details?.provider && DMSData?.vehicle_details?.device?.trim()
                ? t('PLEASE_SELECT_DEVICE_PROVIDER')
                : '',
            device:
              DMSData?.vehicle_details?.provider && !DMSData?.vehicle_details?.device?.trim()
                ? t('PLEASE_ENTER_DEVICE_IMEI')
                : '',
          },
        };
        break;
      }
    }
    setError(updatedError);
  };
  const handleCheckVehicleData = () => {
    const { vehicle_details } = DMSData;
    getErrorData('VEHICLE');
    if (
      !vehicle_details?.organization?.id ||
      !vehicle_details?.front_tire_size?.id ||
      !vehicle_details?.rear_tire_size?.id ||
      !vehicle_details?.engine?.id ||
      !vehicle_details?.plate?.trim() ||
      !vehicle_details?.transmission?.id ||
      !vehicle_details?.environmental_label?.id ||
      !vehicle_details?.status?.id ||
      (!vehicle_details?.provider && vehicle_details?.device?.trim()) ||
      (vehicle_details?.provider && !vehicle_details?.device?.trim())
    ) {
      return false;
    } else {
      return true;
    }
  };
  const handleCheckUserData = () => {
    const { user_details } = DMSData;
    getErrorData('USER');
    if (
      !user_details?.name?.trim() ||
      !user_details?.surname?.trim() ||
      !user_details?.email?.trim() ||
      !user_details?.country_code?.trim() ||
      !user_details?.mobile_no?.trim() ||
      !user_details?.license_no?.trim()
    ) {
      return false;
    } else {
      return true;
    }
  };
  const handleConfirm = () => {
    switch (selectedTab) {
      case 'VEHICLE_DETAILS': {
        const isValid = handleCheckVehicleData();
        if (!isValid) {
          return;
        }

        if (!DMSData?.vehicle_details?.selectedParkingAddress) {
          toast.error(t('administrator_roles.addEdit.errorParkingAddressToastMessage'));
          return;
        }
        setSelectedTab('USER_DETAILS');
        break;
      }
      case 'USER_DETAILS': {
        const isValid = handleCheckUserData();
        if (!isValid) {
          return;
        }
        if (
          DMSData?.user_details?.address &&
          Object.values(DMSData?.user_details?.address).filter(field => String(field)?.trim())
            .length > 0 &&
          Object.values(DMSData?.user_details?.address).filter(field => String(field)?.trim())
            .length < 6
        ) {
          toast.error(t('dms_Integartion.errorallAddressToastMessage'));
          return;
        }
        if (
          DMSData?.user_details?.billing_address &&
          Object.values(DMSData?.user_details?.billing_address).filter(
            field => String(field)?.trim(),
          ).length > 0 &&
          Object.values(DMSData?.user_details?.billing_address).filter(
            field => String(field)?.trim(),
          ).length < 6
        ) {
          toast.error(t('dms_Integartion.errorBillingAddressToastMessage'));
          return;
        }
        handleSubmit();
        break;
      }
    }
  };
  const handleCancel = () => {
    switch (selectedTab) {
      case 'VEHICLE_DETAILS': {
        dispatch(setDMSDeatils(null));
        dispatch(setSideModal(initSideModal));
        break;
      }
      case 'USER_DETAILS':
        setSelectedTab('VEHICLE_DETAILS');
        break;
    }
  };

  return (
    <CommonLayout
      onConfirm={() => handleConfirm()}
      onCancel={() => handleCancel()}
      confirmButtonProps={{
        label:
          selectedTab === 'USER_DETAILS' ? t('dms_Integartion.add') : t('dms_Integartion.next'),
      }}
      cancelButtonProps={{
        label: selectedTab === 'VEHICLE_DETAILS' ? t('CANCEL') : t('dms_Integartion.back'),
      }}
    >
      <div className="flex flex-col w-full p-6 gap-y-2 h-full">
        <div className="flex items-center justify-start w-full gap-x-1">
          {tabs.map(data => (
            <div className="flex items-center gap-x-0.5" key={data?.value}>
              <label
                className={`text-base text-black ${
                  selectedTab === data.value ? 'font-semibold' : ''
                }`}
              >
                {t(`dms_Integartion.${data.value}`)}
              </label>
              <DownIcon className="-rotate-90" />
            </div>
          ))}
        </div>
        <div className="flex w-full border-b-2 my-1"></div>
        <div className="flex flex-1 flex-col overflow-hidden gap-y-2 mt-2">
          {getContent(selectedTab)}
        </div>
      </div>
    </CommonLayout>
  );
};

export default DMSIntegration;
